package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.date_picker.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.pages.components.CircleIcon
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.VectorIcon

@Composable
fun CalendarMonthRow(
    selectedItem: MonthModel,
    onPreviousMonthClick: () -> Unit,
    onNextMonthClick: () -> Unit,
) {


    Box(
        modifier = Modifier
            .margin(bottom = Dimen.largePadding)
            .fillMaxWidth(),

    )
    {

        CustomIcon(
            modifier = Modifier
                .align(Alignment.CenterStart),
            icon =Res.PathIcon.leftArrow,
            iconColor =Theme.ActionActive.hex ,
            onIconClick = {
                onPreviousMonthClick()
            }
        )

        SpanText(
            text = selectedItem.monthName+" "
                    +selectedItem.yearNumber.toString(),
            modifier = Modifier
                .align(Alignment.Center)
                .fontFamily(FontFamily.Jakarta)
                .fontSize(FontSizes.semiLargeFontSize)
                .fontWeight(FontWeight.Medium)
                .color(Theme.TextPrimary.rgb)

        )


        CustomIcon(
            modifier = Modifier
                .align(Alignment.CenterEnd),
            icon =Res.PathIcon.rightArrow,
            iconColor =Theme.ActionActive.hex ,
            onIconClick = {
                onNextMonthClick()
            }
        )



    }


}